export const HOST_BRAUM = "https://appsup4tech.com:9444";
export const HOST_SINGED = "https://appsup4tech.com:8000";
export const HOST_REDUTO = "https://appsup4tech.com:8001";